/*
# Details subview - vendor, date, currency
*/

var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['backbone', 'underscore.string', 'core', 'common/component/money-formatter', 'app-common/component/combobox', 'template/document-entry/details.htm', 'component/document-entry/document-autofill', 'app-common/lib/jquery.flexselect', 'lib/moment'], function(Backbone, _s, core, moneyFormatter, Combobox, detailsTemplate, DocumentAutofill, flexSelect, moment) {
  var DetailsView;
  return DetailsView = (function(_super) {
    var taxDocumentTypesListMap;

    __extends(DetailsView, _super);

    function DetailsView() {
      DetailsView.__super__.constructor.apply(this, arguments);
    }

    DetailsView.prototype.className = 'details-table-wrapper';

    taxDocumentTypesListMap = [
      {
        value: 'UNDEFINED',
        name: 'Undefined or unknown'
      }, {
        value: 'ID',
        name: 'Owner ID Document'
      }, {
        value: 'SPOUSE_ID',
        name: 'Spouse ID Document'
      }, {
        value: 'FORM_1120',
        name: 'Form 1120'
      }, {
        value: 'FORM_1120S',
        name: 'Form 1120s'
      }, {
        value: 'FORM_1040',
        name: 'Form 1040'
      }, {
        value: 'FORM_1040_SCHEDULE_C',
        name: 'Form 1040 Schedule C'
      }, {
        value: 'FORM_1065',
        name: 'Form 1065'
      }, {
        value: 'ARTICLES_OF_INCORPORATION',
        name: 'Articles of Incorporation'
      }, {
        value: 'ARTICLES_OF_ORGANIZATION',
        name: 'Articles of Organization'
      }, {
        value: 'EIN_ACCEPTANCE_FORM',
        name: 'EIN Acceptance letter'
      }, {
        value: 'NOTICE_CP261',
        name: 'Notice CP261 (385C)'
      }, {
        value: 'YEF',
        name: 'Year End Financial (YEF)'
      }, {
        value: 'SUPPLEMENTAL',
        name: 'Supplemental document, needed to file'
      }
    ];

    DetailsView.prototype.template = detailsTemplate;

    DetailsView.prototype.ledgerControl = null;

    DetailsView.prototype.addOnControl = null;

    DetailsView.prototype.documentAddOnControl = null;

    DetailsView.prototype.documentRequestsControl = null;

    DetailsView.prototype.events = {
      'change #addon-id': 'saveAddOn',
      'change #document-addon-id': 'saveDocumentAddOn',
      'change #other-type': 'saveType',
      'change #addon-type': 'saveType',
      'change #document-vendor': 'saveVendor',
      'change #document-date': 'saveDate',
      'change #tax-document-type': 'saveTaxDocumentType',
      'change #tax-year': 'saveTaxYear',
      'change #document-currency': 'saveCurrency',
      'change #document-exchange-rate': 'saveExchangeRate',
      'change #document-name': 'saveName',
      'change .statement-balance': 'saveBalance',
      'change .statement-date': 'saveStatementDate',
      'dropdownPicked .document-ledger-row input[type=text]': 'saveLedger',
      'click #document-date': 'selectDate',
      'click #copy-opening-date': 'copyOpeningDate',
      'click #copy-closing-date': 'copyClosingDate',
      'change #document-request-id': 'saveSelectedDocument'
    };

    DetailsView.prototype.initialize = function(options) {
      this.otherTypes = options.otherTypes;
      this.isTabular = options.isTabular;
      this.documentRequests = options.documentRequests;
      this.prepareDocumentRequests();
      this.documentRequests.on('accepted', this.updateFieldsFromDocumentRequest, this);
      this.documentRequests.on('associateDocument', this.persistLinkedDocument, this);
      this.prepareLedgerControl();
      this.prepareAddOnControl();
      this.prepareDocumentAddOnControl();
      switch (this.model.get('documentType')) {
        case 'UNKNOWN':
          if (this.isTabular) {
            this.model.set('documentType', 'OTHER');
          } else {
            this.model.set('documentType', 'RECEIPT');
          }
      }
      this.model.on('change:currencyExchangeRate', this.refreshExchangeRate, this);
      this.model.on('change:documentType', this.updateType, this);
      this.model.on('change:vendor', this.updateVendor, this);
      this.model.on('change:documentDate', this.updateDate, this);
      this.render();
      this.$el.find("#document-name").trigger('change');
      return this.refreshExchangeRate();
    };

    /*
    # Speed up rendering - use precombined select element
    */


    DetailsView.prototype.prepareLedgerControl = function() {
      var filteredLedgers, ledger, ledgers, _i, _len, _results;
      this.ledgerControl = $('<select/>');
      ledgers = core.getCollection('ledgerAccounts').toJSON();
      filteredLedgers = _.filter(ledgers, function(ledger) {
        return ledger.role != null;
      });
      _results = [];
      for (_i = 0, _len = filteredLedgers.length; _i < _len; _i++) {
        ledger = filteredLedgers[_i];
        _results.push(this.ledgerControl.append($('<option/>').attr('value', ledger.id).text(_s.trim(ledger.name))));
      }
      return _results;
    };

    DetailsView.prototype.createLedgersCombobox = function() {
      var attributes, ledgerAccountId, ledgerControl;
      attributes = this.model.get('attributes');
      ledgerAccountId = attributes != null ? attributes.ledgerAccountId : void 0;
      ledgerControl = this.ledgerControl.clone();
      ledgerControl.attr('id', 'ledgerAccountId');
      if (ledgerAccountId != null) {
        ledgerControl.find("option[value='" + ledgerAccountId + "']").attr('selected', 'selected');
      }
      return $('<div/>').append(ledgerControl).html();
    };

    DetailsView.prototype.prepareAddOnControl = function() {
      var addOn, addOns, _i, _len, _results;
      this.addOnControl = $('<select/>');
      addOns = core.getCollection('addOn').toJSON();
      this.addOnControl.append($('<option value="">Link to an Add On</option>'));
      _results = [];
      for (_i = 0, _len = addOns.length; _i < _len; _i++) {
        addOn = addOns[_i];
        _results.push(this.addOnControl.append($('<option/>').attr('value', addOn.id).text(_s.trim(addOn.name))));
      }
      return _results;
    };

    DetailsView.prototype.createAddOnCombobox = function() {
      var addOnControl, addOnId;
      addOnId = this.model.get('addOnId');
      addOnControl = this.addOnControl.clone();
      addOnControl.attr('id', 'addon-id');
      if (addOnId != null) {
        addOnControl.find("option[value='" + addOnId + "']").attr('selected', 'selected');
      } else {
        addOnControl.find("option[value='']").attr('selected', 'selected');
      }
      return $('<div/>').append(addOnControl).html();
    };

    DetailsView.prototype.prepareDocumentAddOnControl = function() {
      var addOn, documentAddOns, _i, _len, _results;
      this.documentAddOnControl = $('<select/>');
      documentAddOns = core.getCollection('addOn').toJSON();
      this.documentAddOnControl.append($('<option value="">Link to an Add On</option>'));
      _results = [];
      for (_i = 0, _len = documentAddOns.length; _i < _len; _i++) {
        addOn = documentAddOns[_i];
        _results.push(this.documentAddOnControl.append($('<option/>').attr('value', addOn.id).text(_s.trim(addOn.name))));
      }
      return _results;
    };

    DetailsView.prototype.createDocumentAddOnCombobox = function() {
      var attributes, documentAddOnControl, documentAddOnId;
      attributes = this.model.get('attributes');
      documentAddOnId = attributes != null ? attributes.documentAddOnId : void 0;
      documentAddOnControl = this.documentAddOnControl.clone();
      documentAddOnControl.attr('id', 'document-addon-id');
      if (documentAddOnId != null) {
        documentAddOnControl.find("option[value='" + documentAddOnId + "']").attr('selected', 'selected');
      }
      return $('<div/>').append(documentAddOnControl).html();
    };

    /*
    # Speed up rendering - use precombined select element
    # All this just to get a dynamic select box, wild
    */


    DetailsView.prototype.prepareDocumentRequests = function() {
      var documentRequests, documentsEl, _ref, _ref1;
      if (this.documentRequestsControl) {
        documentsEl = $('#document-request-id');
      } else {
        this.documentRequestsControl = $('<select>');
        documentsEl = this.documentRequestsControl;
      }
      documentRequests = this.documentRequests.filterDocType(this.model.get('documentType'));
      documentsEl.empty();
      documentsEl.append($('<option value="" selected>No matched document request</option>'));
      documentRequests.forEach(function(documentRequest) {
        return documentsEl.append($('<option/>').attr('value', documentRequest.get('id')).text(_s.trim(documentRequest.toLabel())));
      });
      if ((_ref = this.model) != null ? _ref.attributes.documentRequestId : void 0) {
        return documentsEl.find("option[value='" + ((_ref1 = this.model) != null ? _ref1.attributes.documentRequestId : void 0) + "']").attr('selected', 'selected');
      }
    };

    DetailsView.prototype.createDocumentRequestCombobox = function() {
      var documentRequestControl;
      documentRequestControl = this.documentRequestsControl.clone();
      documentRequestControl.attr('id', 'document-request-id');
      return $('<div/>').append(documentRequestControl).html();
    };

    DetailsView.prototype.render = function() {
      var addOnTypesCombobox, addOnTypesListMap, addOnsCombobox, currenciesCombobox, currenciesComboboxHtmlObj, documentAddOnsCombobox, documentRequestsCombobox, ledgersCombobox, options, otherTypesListMap, taxTypesCombobox, typesCombobox;
      currenciesCombobox = new Combobox(null, 'document-currency', null, core.getCollection('currencies').toJSON(), this.model.getCurrency().id, {
        name: 'code',
        value: 'id'
      });
      currenciesComboboxHtmlObj = $(currenciesCombobox.controlHtml);
      currenciesComboboxHtmlObj[0]['disabled'] = 'disabled';
      currenciesCombobox.controlHtml = currenciesComboboxHtmlObj[0].outerHTML;
      otherTypesListMap = _.map(this.otherTypes, function(type) {
        type = type.toLowerCase();
        return {
          name: _s.humanize(type),
          value: type
        };
      });
      addOnTypesListMap = _.map(['EXPENSE_REPORT', 'MERCHANT_REPORT', 'LOAN_INTEREST_REPORT', 'PAYROLL_REPORT'], function(type) {
        return {
          name: _s.humanize(type),
          value: type
        };
      });
      addOnTypesCombobox = new Combobox('addon-type', 'addon-type', null, addOnTypesListMap, 'addOn');
      typesCombobox = new Combobox('other-type', 'other-type', null, otherTypesListMap, 'other');
      taxTypesCombobox = new Combobox('tax-document-type', 'tax-document-type', null, taxDocumentTypesListMap, this.model.get('taxDocumentType'));
      documentRequestsCombobox = this.createDocumentRequestCombobox();
      ledgersCombobox = this.createLedgersCombobox();
      addOnsCombobox = this.createAddOnCombobox();
      documentAddOnsCombobox = this.createDocumentAddOnCombobox();
      options = _.extend({
        currenciesCombobox: currenciesCombobox.show(),
        typesCombobox: typesCombobox.show(),
        taxTypesCombobox: taxTypesCombobox.show(),
        ledgersCombobox: ledgersCombobox,
        addOnsCombobox: addOnsCombobox,
        documentAddOnsCombobox: documentAddOnsCombobox,
        documentRequestsCombobox: documentRequestsCombobox,
        addOnTypesCombobox: addOnTypesCombobox.show()
      }, this.model.toJSON());
      return this.$el.html(_.template(this.template, options));
    };

    DetailsView.prototype.initDatePicker = function() {
      $('#document-date').datepicker({
        maxDate: '+0d',
        minDate: new Date(2005, 0, 1)
      });
      return $('.statement-date').each(function() {
        return $(this).datepicker({
          minDate: new Date(2005, 0, 1)
        });
      });
    };

    DetailsView.prototype.initLedgerControl = function() {
      var additionalAttributes, ledgerAccountId, _ref;
      ledgerAccountId = (_ref = this.model.get('attributes')) != null ? _ref.ledgerAccountId : void 0;
      additionalAttributes = (ledgerAccountId != null) && !_.isEmpty(ledgerAccountId) ? {} : void 0;
      ({
        preSelection: false
      });
      $('.document-ledger-row select').flexselect(_.defaults({
        sortAlphabetically: true
      }, additionalAttributes));
      return $('#ledgerAccountId_flexselect').attr('placeholder', 'Ledger Account');
    };

    DetailsView.prototype.saveType = function(e) {
      return this.model.set('documentType', $(e.currentTarget).val().toUpperCase(), {
        silent: true
      });
    };

    DetailsView.prototype.saveVendor = function(e) {
      return this.model.set('vendor', $(e.currentTarget).val());
    };

    DetailsView.prototype.isDateCorrect = function(stringDate, field) {
      var date, minDate, saneDateMaxDate, saneDateMinDate, testedDate, valid;
      date = Date.parse(stringDate);
      if (stringDate.length >= 8 && stringDate.length <= 10 && (date == null)) {
        this.showDateWarning('Date format incorrect', field, false);
        return false;
      }
      valid = true;
      saneDateMinDate = new Date(1950, 1, 1, 0, 0, 0, 0);
      saneDateMaxDate = new Date();
      saneDateMaxDate.setDate(saneDateMaxDate.getDate() + 365);
      minDate = new Date(core.getEarliestTransactionTime()).clearTime().getTime();
      testedDate = date != null ? date.clearTime().getTime() : void 0;
      if (this.model.get('documentType') === 'RECEIPT' && testedDate < minDate) {
        this.showDateWarning('Date is earlier than date of the first transaction', field);
      }
      if (testedDate < saneDateMinDate) {
        this.showDateWarning('That was a long long time ago!', field, false);
        valid = false;
      }
      if (testedDate > saneDateMaxDate) {
        this.showDateWarning('Are you from the future?', field, false);
        valid = false;
      }
      return valid;
    };

    DetailsView.prototype.saveDate = function(e) {
      var element, saveDate,
        _this = this;
      saveDate = function(date) {
        _this.model.set('documentDate', core.formatDate(date));
        return _this.updateDate();
      };
      element = $(e.currentTarget);
      return this.validateAndSaveDate('documentDate', element, saveDate);
    };

    DetailsView.prototype.saveTaxDocumentType = function(e) {
      return this.model.set('taxDocumentType', $(e.currentTarget).val().toUpperCase(), {
        silent: true
      });
    };

    DetailsView.prototype.saveTaxYear = function(e) {
      var value;
      value = +$('#tax-year').val();
      return this.model.set('taxYear', value || null);
    };

    DetailsView.prototype.saveAddOn = function(e) {
      return this.model.set('addOnId', $('#addon-id').val() || null);
    };

    DetailsView.prototype.saveCurrency = function(e) {
      var currentCurrencyId, defaultCurrencyId, exchangeRate;
      defaultCurrencyId = core.getDefaultCurrency().id;
      currentCurrencyId = $(e.currentTarget).val();
      if (defaultCurrencyId !== currentCurrencyId) {
        exchangeRate = _.findWhere(core.getCollection('exchangerates').toJSON(), {
          currencyId: currentCurrencyId
        });
        this.model.set('currencyExchangeRate', exchangeRate.rate);
      } else {
        this.model.set('currencyExchangeRate', null);
      }
      return this.model.set('currencyId', currentCurrencyId);
    };

    DetailsView.prototype.saveExchangeRate = function(e) {
      var exchangeRate;
      exchangeRate = $(e.currentTarget).val();
      this.model.set('currencyExchangeRate', exchangeRate);
      return this.model.trigger('recalculate');
    };

    DetailsView.prototype.saveBalance = function(e) {
      var element, value;
      element = $(e.currentTarget);
      value = element.val();
      if (value) {
        value = moneyFormatter.formatNumber(element.val());
        element.val(value);
      } else {
        value = null;
      }
      return this.saveAttribute(element.attr('id'), value);
    };

    DetailsView.prototype.saveStatementDate = function(e) {
      var closingDate, element, field, openingDate, saveDate,
        _this = this;
      saveDate = function(date) {
        if (field === 'closingDate') {
          _this.model.set('documentDate', core.formatDate(date));
          element.val(_this.model.get('documentDate'));
        }
        _this.saveAttribute(field, core.formatDate(date));
        return element.val(_this.model.get('attributes')[field]);
      };
      element = $(e.currentTarget);
      field = element.attr('id');
      this.validateAndSaveDate(field, element, saveDate);
      openingDate = Date.parse($("#openingDate").val());
      closingDate = Date.parse($("#closingDate").val());
      if ((openingDate != null) && (closingDate != null) && openingDate > closingDate) {
        return this.renderError('openingDate', 'Closing date is earlier than opening date', 'validation-warning', true);
      }
    };

    DetailsView.prototype.copyOpeningDate = function(e) {
      var openingDate;
      openingDate = Date.parse($("#openingDate").val());
      if (openingDate) {
        return $("#closingDate").val(core.formatDate(openingDate.add(1).month().add(-1).day())).change();
      } else {
        return this.renderError('openingDate', 'Opening date must be present to perform this action', 'validation-warning', true);
      }
    };

    DetailsView.prototype.copyClosingDate = function(e) {
      var closingDate;
      closingDate = Date.parse($("#closingDate").val());
      return $("#openingDate").val(core.formatDate(closingDate.add(-1).month().add(1).day())).change();
    };

    DetailsView.prototype.validateAndSaveDate = function(field, element, saveDate) {
      var date, value;
      value = element.val();
      value = core.formatYearCorrectly(value);
      date = Date.parse(value);
      if (date === null || !this.isDateCorrect(value, field)) {
        date = new Date();
        if (saveDate != null) {
          saveDate.call(this, date);
        }
        element.select();
      } else {
        if (saveDate != null) {
          saveDate.call(this, date);
        }
      }
      return date;
    };

    DetailsView.prototype.saveLedger = function() {
      return this.saveAttribute('ledgerAccountId', $('#ledgerAccountId').val());
    };

    DetailsView.prototype.saveDocumentAddOn = function() {
      return this.saveAttribute('documentAddOnId', $('#document-addon-id').val());
    };

    DetailsView.prototype.saveAttribute = function(name, value) {
      var attributes;
      attributes = this.model.get('attributes');
      attributes[name] = value;
      return this.model.set('attributes', attributes);
    };

    DetailsView.prototype.saveName = function(e) {
      var element;
      element = $(e.currentTarget);
      return this.saveAttribute('name', element.val());
    };

    DetailsView.prototype.refreshExchangeRate = function() {
      var exchangeRate;
      exchangeRate = this.model.get('currencyExchangeRate');
      if (exchangeRate != null) {
        return this.$el.find('.exchange-rate-wrapper').show().find('#document-exchange-rate').val(exchangeRate);
      } else {
        return this.$el.find('.exchange-rate-wrapper').hide();
      }
    };

    DetailsView.prototype.updateType = function() {
      var allClasses, currentDropdownValue, hiddenClasses, type, visibleClasses, visibleClassesByType,
        _this = this;
      type = this.model.get('documentType');
      allClasses = ['.currency-row', '.type-row', '.vendor-row', '.balances-row', '.name-row', '.statement-dates-row', '.document-date-row', '.document-ledger-row', '.addon-row', '.tax-document-type-row', '.tax-year-row', '.document-requests-row', '.addOns-type-row', '.document-addon-row'];
      visibleClassesByType = {
        'RECEIPT': ['.vendor-row', '.document-date-row', '.document-requests-row'],
        'TRANSACTIONAL': ['.currency-row', '.vendor-row', '.document-date-row', '.addon-row', '.document-requests-row'],
        'STATEMENT': ['.balances-row', '.name-row', '.statement-dates-row', '.document-ledger-row', '.document-requests-row'],
        'TAX': ['.name-row', '.document-date-row', '.tax-document-type-row', '.tax-year-row', '.document-requests-row'],
        'EXPORTS': ['.name-row', '.document-date-row', '.document-requests-row'],
        'PAYROLL_REPORT': ['.name-row', '.document-date-row', '.document-requests-row', '.addOns-type-row', '.document-addon-row'],
        'EXPENSE_REPORT': ['.name-row', '.document-date-row', '.document-requests-row', '.addOns-type-row', '.document-addon-row'],
        'MERCHANT_REPORT': ['.name-row', '.document-date-row', '.document-requests-row', '.addOns-type-row', '.document-addon-row'],
        'LOAN_INTEREST_REPORT': ['.name-row', '.document-date-row', '.document-requests-row', '.addOns-type-row', '.document-addon-row'],
        'OTHER': ['.type-row', '.name-row', '.document-date-row', '.document-requests-row', '.document-requests-row'],
        'INTERNAL': ['.name-row', '.document-date-row', '.document-requests-row']
      };
      visibleClasses = visibleClassesByType['OTHER'];
      if (type === 'RECEIPT' || type === 'TRANSACTIONAL' || type === 'STATEMENT' || type === 'TAX' || type === 'EXPORTS' || type === 'PAYROLL_REPORT' || type === 'EXPENSE_REPORT' || type === 'MERCHANT_REPORT' || type === 'LOAN_INTEREST_REPORT' || type === 'INTERNAL') {
        visibleClasses = visibleClassesByType[type];
      }
      hiddenClasses = _.difference(allClasses, visibleClasses);
      _.each(visibleClasses, function(className) {
        return _this.$el.find(className).show();
      });
      _.each(hiddenClasses, function(className) {
        return _this.$el.find(className).hide();
      });
      if (type === 'STATEMENT') {
        this.saveLedger();
      }
      if (type !== 'RECEIPT' && type !== 'TRANSACTIONAL' && type !== 'STATEMENT' && type !== 'TAX' && type !== 'EXPORTS' && type !== 'PAYROLL_REPORT' && type !== 'EXPENSE_REPORT' && type !== 'MERCHANT_REPORT' && type !== 'LOAN_INTEREST_REPORT' && type !== 'INTERNAL') {
        this.$el.find('#other-type').val(type.toLowerCase());
        $('.document-type-other').data('type', type.toLowerCase());
      }
      if (core.getFeatureFlagValue('documentRequests')) {
        this.prepareDocumentRequests();
      } else {
        this.$el.find('.document-requests-row').hide();
      }
      if (type === 'PAYROLL_REPORT' || type === 'EXPENSE_REPORT' || type === 'MERCHANT_REPORT' || type === 'LOAN_INTEREST_REPORT') {
        currentDropdownValue = $("#addon-type").val();
        if (currentDropdownValue !== type) {
          return $("#addon-type").val(type);
        }
      }
    };

    DetailsView.prototype.updateVendor = function() {
      return $('#document-vendor').val(this.model.get('vendor'));
    };

    DetailsView.prototype.updateDate = function() {
      return $('#document-date').val(this.model.get('documentDate'));
    };

    DetailsView.prototype.selectDate = function() {
      return $('#document-date').select();
    };

    DetailsView.prototype.showDateWarning = function(message, dateField, warning) {
      var warningClass;
      if (dateField == null) {
        dateField = 'documentDate';
      }
      if (warning == null) {
        warning = true;
      }
      warningClass = warning === true ? 'validation-warning' : null;
      return this.renderError(dateField, message, warningClass, true);
    };

    DetailsView.prototype.saveSelectedDocument = function(event) {
      var request;
      request = this.documentRequests.get(event.target.value);
      return this.updateFieldsFromDocumentRequest(request);
    };

    DetailsView.prototype.updateFieldsFromDocumentRequest = function(documentRequest) {
      var docRequestDocumentType, flexselect;
      if (!documentRequest) {
        this.saveAttribute('documentRequestId', null);
        return;
      }
      this.saveAttribute('documentRequestId', documentRequest.attributes.id);
      $("#document-date").val(moment(documentRequest.get('date')).endOf('month').format('MM/DD/YYYY')).change();
      switch (this.model.get('documentType')) {
        case 'STATEMENT':
          $("#closingDate").val(moment(documentRequest.get('date')).endOf('month').format('MM/DD/YYYY')).change();
          if (documentRequest.get('ledgerAccountName')) {
            flexselect = $('#ledgerAccountId_flexselect');
            flexselect.focus();
            flexselect.trigger({
              type: 'keydown',
              keyCode: 39
            });
            flexselect.trigger({
              type: 'keyup',
              keyCode: 39
            });
            flexselect.val(documentRequest.get('ledgerAccountName'));
            flexselect.trigger({
              type: 'keydown',
              keyCode: 39
            });
            flexselect.trigger({
              type: 'keyup',
              keyCode: 39
            });
            flexselect.trigger({
              type: 'keydown',
              keyCode: 13
            });
            flexselect.trigger({
              type: 'keyup',
              keyCode: 13
            });
            flexselect.blur();
          }
          break;
        case 'TAX':
          $("#tax-document-type").val(documentRequest.get("taxDocumentType")).change();
          $("#tax-year").val(moment(documentRequest.get('date')).format('YYYY')).change();
          break;
        case 'OTHER':
          $("#other-type").val(documentRequest.get('documentType'.toLowerCase())).change();
          break;
        case 'PAYROLL_REPORT':
        case 'EXPENSE_REPORT':
        case 'MERCHANT_REPORT':
        case 'LOAN_INTEREST_REPORT':
          docRequestDocumentType = documentRequest.attributes.documentType;
          if (docRequestDocumentType) {
            $("#addon-type").val(docRequestDocumentType).on('change', docRequestDocumentType);
          }
          if (documentRequest.attributes.addOnId) {
            $("#document-addon-id").val(documentRequest.attributes.addOnId).change();
          }
      }
      return $('#document-request-id').find("option[value='" + documentRequest.attributes.id + "']").attr('selected', 'selected');
    };

    DetailsView.prototype.persistLinkedDocument = function(documentModel, onSuccess, onFail) {
      var documentId, documentRequestId, selectedDocumentRequest;
      documentId = documentModel.get('financialDocumentId');
      documentRequestId = documentModel.get('attributes')['documentRequestId'];
      if (documentRequestId !== "") {
        selectedDocumentRequest = this.documentRequests.get(documentRequestId);
        if (selectedDocumentRequest) {
          selectedDocumentRequest.associateWithDocument(documentId);
          return this.documentRequests.remove(selectedDocumentRequest);
        }
      }
    };

    DetailsView.prototype.prefillFromMetadata = function() {
      var prefiller;
      prefiller = new DocumentAutofill(this.model, this.parentPage);
      return prefiller.prefillFromMetadata();
    };

    return DetailsView;

  })(Backbone.View);
});
